import { Box, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import { useZudokuTheme } from "../hooks/useZudokuTheme";
import { ApiKeyIdentities } from "./ApiKeyIdentities";
import { EntityIdentitiesTab } from "./EntityIdentities";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`api-identities-tabpanel-${index}`}
      aria-labelledby={`api-identities-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, backgroundColor: "transparent" }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `api-identities-tab-${index}`,
    "aria-controls": `api-identities-tabpanel-${index}`,
  };
}

export function ApiIdentities() {
  const { currentTheme } = useZudokuTheme();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const refreshData = async () => {};

  const NODE_ENV = import.meta.env.ZUDOKU_PUBLIC_NODE_ENV;
  const enableEntityIdentities = NODE_ENV !== "production";

  if (enableEntityIdentities) {
    return (
      <Box
        sx={{
          backgroundColor: currentTheme.card,
          borderRadius: 1,
          overflow: "hidden",
          width: "100%",
          border: `1px solid ${currentTheme.border}`,
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: currentTheme.border,
            backgroundColor: currentTheme.card,
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="API identities tabs"
            sx={{
              px: 2,
              "& .MuiTab-root": {
                minHeight: "48px",
                transition: "all 0.2s ease-in-out",
              },
              "& .MuiTabs-indicator": {
                height: 3,
                borderRadius: "2px 2px 0 0",
              },
            }}
          >
            <Tab label="API Keys" {...a11yProps(0)} />
            <Tab label="Entity Identities" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <ApiKeyIdentities onRefresh={refreshData} />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <EntityIdentitiesTab onRefresh={refreshData} />
        </TabPanel>
      </Box>
    );
  }

  return <ApiKeyIdentities onRefresh={refreshData} />;
}
